import AppCard from '@nxsys/components/AppCard';
import AppIconCard from '@nxsys/components/AppIconCard';
import { useGetStatisticsOthers } from '@nxsys/hooks/api/dashboard';
import { useNavigateWithQuery } from '@nxsys/hooks/useNavigateWithQuery';
import { getCurrentTaxMonth, getTaxWeekTaxYear } from '@nxsys/utils/taxYear';
import { useEffect, useMemo, useState } from 'react';
import CIS300Modal from './components/CIS300Modal';
import EPSModal from './components/EPSModal';
import FPSModal from './components/FPSModal';
import RTIFillingSection from './components/RTIFillingSection';

const RTIFilling = () => {
  const currentTaxMonth = getCurrentTaxMonth();
  const currentTaxWeekTaxYear = getTaxWeekTaxYear();
  const navigate = useNavigateWithQuery();

  const { value: othersValue, run: runOthers } = useGetStatisticsOthers();
  const othersData = useMemo(() => othersValue?.data, [othersValue]);

  const [isCIS300ModalOpen, setIsCIS300ModalOpen] = useState(false);
  const [isEPSModalOpen, setIsEPSModalOpen] = useState(false);
  const [isFPSModalOpen, setIsFPSModalOpen] = useState(false);

  useEffect(() => {
    runOthers();
  }, []);

  const fpsErrors = othersData?.FPS?.countErrors ?? 0;
  const epsErrors = othersData?.EPS?.countErrors ?? 0;
  const cis300Errors = othersData?.CIS300?.countErrors ?? 0;

  return (
    <div className="RTIFilling">
      <AppCard className="p-[24px]">
        <AppIconCard
          iconName="IconStarShooting"
          title="RTI Filling"
          className="mb-[24px]"
        />
        <div className="grid grid-cols-3 gap-[16px] max-sm:grid-cols-1">
          <RTIFillingSection
            title="CIS 300"
            description={`Upcoming period tax month ${currentTaxMonth?.taxMonth ?? ''}`}
            startDate={currentTaxMonth?.startTaxMonth}
            endDate={currentTaxMonth?.endTaxMonth}
            onClick={() => setIsCIS300ModalOpen(true)}
            errorCount={cis300Errors}
            onErrorClick={() => navigate('/rti-filings/cis-300')}
          />
          <RTIFillingSection
            title="FPS"
            description={`Tax Year ${currentTaxWeekTaxYear?.taxYear} - ${currentTaxWeekTaxYear?.taxYear + 1}`}
            onClick={() => setIsFPSModalOpen(true)}
            errorCount={fpsErrors}
            onErrorClick={() => navigate('/rti-filings/fps')}
          />
          <RTIFillingSection
            title="EPS"
            description={`Upcoming period tax month ${currentTaxMonth?.taxMonth ?? ''}`}
            startDate={currentTaxMonth?.startTaxMonth}
            endDate={currentTaxMonth?.endTaxMonth}
            onClick={() => setIsEPSModalOpen(true)}
            errorCount={epsErrors}
            onErrorClick={() => navigate('/rti-filings/eps')}
          />
        </div>
      </AppCard>
      <CIS300Modal
        isOpen={isCIS300ModalOpen}
        toggle={() => setIsCIS300ModalOpen(!isCIS300ModalOpen)}
      />
      <EPSModal
        isOpen={isEPSModalOpen}
        toggle={() => setIsEPSModalOpen(!isEPSModalOpen)}
      />
      <FPSModal
        isOpen={isFPSModalOpen}
        toggle={() => setIsFPSModalOpen(!isFPSModalOpen)}
      />
    </div>
  );
};

export default RTIFilling;
